
export default {
    data() {
        return {
            apis:{
                list: 'sh/org/list'
            },
            orgs: [],//多选时，选中的组织机构
            org: null,//单选时，选中的组织机构
        };
    },
    props: {
        multiple: {//允许多选
            type: Boolean,
            default: true
        },
        orgKey: {//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
            type: String,
            default: null
        },
        orgCode:{//指定机构，如果指定该参数，则仅仅加载该机构及其子机构
            type: String,
            default: null
        },
        selections:{
            type: Array,
            default(){
                return [];
            }
        }
    },

    mounted() {
        const me = this;
        me.orgs = [];
        me.org = null;
        me.initSelection();
    },
    methods: {
        orgClick(data) {
            const me = this, org = data.org;
            if (me.multiple) {
                let exist = false;
                for(let i = 0,n = me.orgs.length; i < n; i++){
                    let o = me.orgs[i];
                    if(org.id == o.id){
                        exist = true;
                    }
                }
                !exist && me.orgs.push(data.org);
            } else {
                me.org = data.org;
                me.orgs = [me.org];
            }
        },
        getOrg(){
            const me = this;
            return me.multiple ? me.orgs : me.org;
        },
        remove(key){
            const me = this;
            if(me.multiple){
                for(let i = 0,n = me.orgs.length; i < n; i++){
                    let org = me.orgs[i];
                    if(org.id == key){
                    me.orgs.splice(i, 1);
                    }
                }
            }else{
                me.orgs = [];
                me.org = null;
            }
        },
        initSelection(){//初始化已经存在的人员列表
            const me = this;
            me.orgs = [];
            me.org = null;
            if (!!!me.selections || me.selections.length <= 0) {
                return;
            }
            me.$post({
                url: me.apis.list,
                params: {
                    keys : me.selections
                }
            }).then(rsp => {
                if(rsp.success && rsp.total > 0){
                    me.orgs = rsp.retList;
                    me.org = me.orgs[0];
                }
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/picker/src/picker.js